import {Injectable, Injector} from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {Router} from '@angular/router';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /**
     * Constructor
     */
    constructor(private _authService: AuthService,
                private _injector: Injector,
                private _router: Router) {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            tap(
                event => null,
                error => this.handleError(req, error)
            ));
    }

    handleError(req: HttpRequest<any>, event: any) {

        const fp = 'forgot-password';
        const si = 'sign-in';

        if (req.url.includes(fp)) {
            return;
        }
        if (req.url.includes(si)) {
            return;
        }

        if (event.status === 500) {
            this._router.navigate(['/500-internal-server-error']).then();
        }
        if (event.status === 422) {
            this._router.navigate(['/500-internal-server-error']).then();
        }
        if (event.status === 400) {
            this._router.navigate(['/404-not-found']).then();
        }
        if (event.status === 404) {
            this._router.navigate(['/404-not-found']).then();
        }
        if (event.status === 503) {
            this._router.navigate(['/maintenance']).then();
        }


    }
}
